import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { NegocioIndexComponent } from './NegocioIndex.component';
import { DialogConfirmacion } from './NegocioIndex.component';
import { NegocioEditComponent } from './NegocioEdit.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [
    {
        path     : 'Negocio',
        component: NegocioIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Negocio',
          nombreFormulario : 'Negocios'
        } 
    },
    {
        path     : 'Negocio/:id',
        component: NegocioEditComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Negocio',
          nombreFormulario : 'Editar Negocio'
        } 
    }
    
];

@NgModule({
    declarations: [
        NegocioIndexComponent,
        NegocioEditComponent,
        DialogConfirmacion
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        NegocioIndexComponent,
        NegocioEditComponent
    ],
    bootstrap: [NegocioIndexComponent, DialogConfirmacion],
})

export class NegocioModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Negocio/Negocio.module.ts